import axios from "axios";
import { IWindowData } from "../Interfaces/IWindowData";
import { ISrvConnector } from "./ISrvConnector";


export class SrvConnector implements ISrvConnector {

    private _WindowData: IWindowData;

    constructor() {

        this._WindowData = window as any;
        axios.defaults.baseURL = this._WindowData.PublicSec.baseUrl;
        axios.defaults.headers.common["X-WP-Nonce"] = this._WindowData.PublicSec.nonceQuery;

    }

    public get WindowData(): IWindowData {
        return this._WindowData;
    }

    public set WindowData(v: IWindowData) {
        this._WindowData = v;
    }


}